import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { DIALOG_STYLE } from "./components/DeleteResourcesDialog";

export const DeleteResources: FC = () => {
  const { t } = useTranslation("dialogs");

  return <SimpleDialogFallback context={{ ...DIALOG_STYLE, title: `${t("deleteResources.deletion")}...` }} />;
};
